import { render, staticRenderFns } from "./IdoneitaUrineViewComponent.vue?vue&type=template&id=ab4bef9a"
import script from "./IdoneitaUrineViewComponent.vue?vue&type=script&lang=js"
export * from "./IdoneitaUrineViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports